import { render } from "./ModuleEducationHr.vue?vue&type=template&id=4263ca16"
import script from "./ModuleEducationHr.vue?vue&type=script&lang=js"
export * from "./ModuleEducationHr.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__